"use strict";

var $ = require("jquery");

$(document).ready(function () {

    $('select').addClass('custom-select');
});